<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CB0CTd/tc-custom/9781460386507.jpg?1726871242608" alt="This image is the cover for the book Sheikh's Christmas Conquest, The Bond of Billionaires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sheikh's Christmas Conquest, The Bond of Billionaires
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: It’s not carolers at the door on this snowy night—it’s a royal billionaire come to spirit her away . . . </b><br/><br/>Sheikh Saladin Al Mektala isn’t used to being disobeyed. Incomprehensibly, the woman he summoned to help his favorite mare—the best horse “whisperer” in the world—turned his generous offer down! So he takes matters into his own hands. <br/><br/>The snow is falling, the fire is roaring, and the mince pies are in the oven when innocent Olivia Miller finds a darkly handsome and physically compelling man on her doorstep . . . The sheikh she dared to refuse is here to whisk her off to his kingdom—and this time he won’t take no for an answer!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article"><P>Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c1c212e